import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import './ChannelHeader.css';

const INFO_ICON = <svg fill='currentColor' width='1em' height='1em' viewBox='0 0 24 24'>
  <path d='M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' />
</svg>;

const ChannelDetailsButton = ({
  onClick
}) => (
  <Tooltip title='View channel details' placement='bottom-start'>
    <div className='channel-header-action-container' onClick={onClick}>
      { INFO_ICON }
    </div>
  </Tooltip>
);

ChannelDetailsButton.propTypes = {
  count: PropTypes.number,
  onClick: PropTypes.func
};

export default ChannelDetailsButton;
